// Copyright © 2019-2026 Focal Systems. All rights reserved.

import { ShieldOff } from "lucide-react";
import { useTranslation } from "react-i18next";
import { PageHeader } from "@/components/layout/page-header";
import { StatusPage, StatusPageChip } from "@/components/shared/status-page";

const ILLUSTRATION = { light: "/forbidden-light.webp", dark: "/forbidden-dark.webp" };

interface AccessDeniedProps {
  permission?: string;
}

export function AccessDenied({ permission }: AccessDeniedProps) {
  const { t } = useTranslation("back-office");
  return (
    <div className="flex min-h-full flex-col">
      <PageHeader title={t("accessDenied.title")} icon={ShieldOff} />
      <StatusPage
        illustration={ILLUSTRATION}
        title={t("accessDenied.title")}
        description={t("accessDenied.description")}
        detail={permission && <StatusPageChip>{t("accessDenied.missingPermission", { permission })}</StatusPageChip>}
      />
    </div>
  );
}
